/**
 * Korean (KRW) mock schedules for the scheduled-transactions use case.
 * A schedule with both source and destination accounts is a schedule pair,
 * rendered by DoubleRow.
 */

/** @type {Array<import('../../mock-schedules.js').MockSchedule>} */
export const MOCK_SCHEDULES_KO = [
	{
		id: 'sch-1',
		nextDate: '2026-08-27',
		transactionType: 'Credit Card Payment',
		estimatedAmount: 1240000,
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		displayAccount: '새봄은행',
		displayFreq: 'Monthly',
		description: '리워드 카드 자동이체',
	},
	{
		id: 'sch-2',
		nextDate: '2026-08-10',
		transactionType: 'Withdrawal',
		estimatedAmount: 1100000,
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		displayAccount: '새봄은행',
		displayFreq: 'Monthly',
		description: '월세',
	},
	{
		id: 'sch-3',
		nextDate: '2026-08-15',
		transactionType: 'Regular Investment',
		estimatedAmount: 500000,
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		displayAccount: '새봄은행',
		displayFreq: 'Monthly',
		description: '펀드 적립',
	},
	{
		id: 'sch-4',
		nextDate: '2026-08-05',
		transactionType: 'Deposit',
		estimatedAmount: 3500000,
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		displayAccount: '새봄은행',
		displayFreq: 'Monthly',
		description: '월급',
	},
	{
		id: 'sch-5',
		isSchedulePair: true,
		nextDate: '2026-09-01',
		transactionType: 'Transfer',
		estimatedAmount: 500000,
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		displayAccount: '새봄은행',
		displaySourceAccount: '새봄은행',
		displayDestAccount: '정기예금',
		displayFreq: 'Monthly',
		description: '저축으로',
		pairedType: 'Transfer',
		pairedCurrencySymbol: '\u20A9',
		pairedCurrencyDecimalPlaces: 0,
	},
];
